module.exports = __webpack_public_path__ + "img/zhu_yj_zhaoxizi.f7f1444b.jpg";